/* Cloofs – Winkelwagen (drawer): aantal in de kop, reserveringsregel, cadeau-drempel, "Vaak samen gekocht" en verwijderen.
   Geladen met defer door sections/cloofs-cart-drawer. Impulse ververst [data-products] na elke wijziging;
   deze code luistert daarop (MutationObserver) en werkt de eigen onderdelen bij. Geen externe bibliotheken. */
(() => {
  if (window.cloofsCartLoaded) return;
  window.cloofsCartLoaded = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return store.mem[k] || null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { store.mem[k] = v; } },
    del(k) { try { window.localStorage.removeItem(k); } catch (e) { delete store.mem[k]; } },
    mem: {}
  };
  const money = (cents) => (window.theme && theme.Currency && theme.settings
    ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
    : '€' + (cents / 100).toFixed(2).replace('.', ','));
  const rebuild = () => document.dispatchEvent(new CustomEvent('cart:build'));

  /* ---------- Reservering ----------
     Start bij het eerste product. Komt er een product bij of gaat er een af (aantal artikelen verandert),
     dan begint de timer opnieuw. Herladen van de pagina laat de timer gewoon doorlopen. Op 00:00 start hij
     opnieuw vanaf het ingestelde aantal minuten; de regel verdwijnt alleen als de winkelwagen leeg is. */
  const KEY = 'cloofsReserveUntil';
  const KEY_COUNT = 'cloofsReserveCount';
  class CloofsReservation extends HTMLElement {
    connectedCallback() {
      this.minutes = Number(this.dataset.minutes) || 10;
      this.active = this.querySelector('[data-reserve-active]');
      this.expired = this.querySelector('[data-reserve-expired]');
      this.time = this.querySelector('[data-reserve-time]');
    }
    update(count) {
      clearInterval(this.timer);
      if (!count) { store.del(KEY); store.del(KEY_COUNT); this.hidden = true; return; }
      let until = Number(store.get(KEY));
      if (!until || store.get(KEY_COUNT) !== String(count)) {
        until = Date.now() + this.minutes * 60000;
        store.set(KEY, String(until));
        store.set(KEY_COUNT, String(count));
      }
      this.until = until;
      this.hidden = false;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      let left = Math.ceil((this.until - Date.now()) / 1000);
      /* Op 00:00 begint de timer opnieuw: de regel blijft altijd staan zolang er iets in de winkelwagen zit. */
      if (left <= 0) {
        this.until = Date.now() + this.minutes * 60000;
        store.set(KEY, String(this.until));
        left = this.minutes * 60;
      }
      this.active.hidden = false;
      if (this.expired) this.expired.hidden = true;
      const pad = (n) => String(n).padStart(2, '0');
      this.time.textContent = `${pad(Math.floor(left / 60))}:${pad(left % 60)}`;
    }
  }
  if (!customElements.get('cloofs-reservation')) customElements.define('cloofs-reservation', CloofsReservation);

  /* ---------- Drawer ---------- */
  const drawer = document.querySelector('[data-cloofs-cart]');
  if (!drawer) return;
  const products = drawer.querySelector('[data-products]');
  const countEl = drawer.querySelector('[data-cloofs-count]');
  const reservation = drawer.querySelector('cloofs-reservation');
  const gift = drawer.querySelector('[data-cloofs-gift]');
  const recs = drawer.querySelector('[data-cloofs-recs]');
  const recsUrl = drawer.dataset.recsUrl;
  let recsKey = '';

  const onRebuild = () => {
    const items = products.querySelector('.cart__items');
    if (!items) return;
    const count = Number(items.dataset.count) || 0;
    const subtotal = Number(items.dataset.cartSubtotal) || 0;
    if (countEl) countEl.textContent = `(${count})`;
    /* Totaal: oorspronkelijke prijs doorgestreept als er korting op zit */
    const original = drawer.querySelector('[data-cloofs-original]');
    if (original) {
      let sum = 0;
      items.querySelectorAll('[data-original]').forEach((row) => { sum += Number(row.dataset.original) || 0; });
      original.hidden = !(sum > subtotal);
      if (sum > subtotal) original.textContent = money(sum);
    }
    if (reservation && reservation.update) reservation.update(count);
    if (gift) updateGift(subtotal, count);
    if (recs && recsUrl) loadRecs(items, count);
  };

  function updateGift(subtotal, count) {
    const threshold = Number(gift.dataset.threshold) || 0;
    gift.hidden = !count || !threshold;
    if (gift.hidden) return;
    const left = Math.max(0, threshold - subtotal);
    gift.querySelector('[data-gift-left]').textContent = money(left);
    gift.querySelector('[data-gift-todo]').hidden = left === 0;
    gift.querySelector('[data-gift-done]').hidden = left > 0;
    gift.querySelector('[data-gift-bar]').style.width = Math.min(100, (subtotal / threshold) * 100) + '%';
  }

  function loadRecs(items, count) {
    const ids = [...items.querySelectorAll('[data-product-id]')].map((el) => el.dataset.productId);
    if (!count || !ids.length) { recs.hidden = true; recsKey = ''; return; }
    const key = ids.join(',');
    if (key === recsKey) return;
    recsKey = key;
    fetch(`${recsUrl}&product_id=${ids[0]}`)
      .then((r) => r.text())
      .then((html) => {
        if (key !== recsKey) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const list = doc.querySelector('[data-recs-list]');
        const track = recs.querySelector('[data-recs-track]');
        track.innerHTML = list ? list.innerHTML : '';
        recs.hidden = !track.children.length;
        track.scrollLeft = 0;
      })
      .catch(() => { recs.hidden = true; });
  }


  new MutationObserver(onRebuild).observe(products, { childList: true });
  onRebuild();

  /* ---------- Klikken in de drawer ---------- */
  const removeLine = (key, row) => {
    if (row) row.classList.add('is-loading');
    fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then((r) => r.json())
      .then((cart) => document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })))
      .finally(rebuild);
  };
  /* − bij aantal 1 = product verwijderen (vóór Impulse, die anders op 1 blijft staan) */
  drawer.addEventListener('click', (e) => {
    const minus = e.target.closest('.js-qty__adjust--minus');
    if (!minus) return;
    const row = minus.closest('.cart__item');
    const input = row && row.querySelector('.js-qty__num');
    if (input && Number(input.value) <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      removeLine(row.dataset.key, row);
    }
  }, true);
  drawer.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cloofs-remove]');
    if (remove) {
      e.preventDefault();
      removeLine(remove.dataset.cloofsRemove, remove.closest('.cart__item'));
      return;
    }
    const arrow = e.target.closest('[data-recs-prev], [data-recs-next]');
    if (arrow && recs) {
      /* Naar de eerstvolgende kaart scrollen, precies op de snap-positie (anders vechten snap en smooth scroll). */
      const track = recs.querySelector('[data-recs-track]');
      const cards = [...track.querySelectorAll('.cloofs-rc')];
      if (!cards.length) return;
      const pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const base = track.getBoundingClientRect().left + pad;
      const starts = cards.map((c) => Math.round(c.getBoundingClientRect().left - base + track.scrollLeft));
      const cur = track.scrollLeft;
      let target;
      if (arrow.hasAttribute('data-recs-next')) target = starts.find((s) => s > cur + 2);
      else target = [...starts].reverse().find((s) => s < cur - 2);
      if (target === undefined) return;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: target, behavior: 'smooth' });
      clearTimeout(track._snapT);
      track._snapT = setTimeout(() => { track.style.scrollSnapType = ''; }, 500);
      return;
    }

    const toggle = e.target.closest('[data-rc-toggle]');
    if (toggle) {
      const card = toggle.closest('.cloofs-rc');
      const sizes = card.querySelector('[data-rc-sizes]');
      const open = sizes.hidden;
      drawer.querySelectorAll('[data-rc-sizes]').forEach((s) => { s.hidden = true; });
      drawer.querySelectorAll('[data-rc-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      sizes.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }

    const add = e.target.closest('[data-rc-add]');
    if (add) {
      add.disabled = true;
      add.classList.add('is-loading');
      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.rcAdd), quantity: 1 }] })
      })
        .then((r) => r.json())
        .then(() => rebuild())
        .catch(() => { add.disabled = false; add.classList.remove('is-loading'); });
    }
  });
})();
